module.exports = __webpack_public_path__ + "static/media/logo2.135d5ebf.jpg";